import { ForexBuyState } from "@/feature/Forex/store/buy/interface";
import { mapForexBuyCreatedDraft } from "@/feature/Forex/api/form/forex-form.utils";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";

export default <ForexBuyState> {
	currentDraft: mapForexBuyCreatedDraft(),
	uploadFileRequests: {},
	preventNextRoute: true,
	operationType: ForexOperationType.BUY,
	currentDraftRequest: null,
	draftIsSent: false,
}